import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Typography, Result } from 'antd';
import api from '../api';
import CallDetailView from '../components/CallDetailView';
import { useBackFallback, usePageLabel } from '../components/BackChip';

export default function CallDetailPage() {
  const { contactId } = useParams();
  // The Back chip (Layout): back where you came from, else this list.
  useBackFallback('/search', 'Search');
  usePageLabel(`Call ${contactId}`);
  const [detail, setDetail]   = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    setError(null);
    api.get(`/api/calls/${contactId}`)
      .then((res) => setDetail(res.data))
      .catch((err) => {
        const status = err.response?.status;
        if (status === 403) {
          setError('You do not have access to this call. It may belong to a campaign outside your access. Contact your QA administrator if you believe this is an error.');
        } else if (status === 404) {
          setError('This call could not be found.');
        } else {
          setError('Could not load call details. Please try again.');
        }
      })
      .finally(() => setLoading(false));
  }, [contactId]);

  return (
    <>
      {error ? (
        <Result
          status="403"
          title={`Contact ${contactId}`}
          subTitle={error}
        />
      ) : (
        <>
          <Typography.Title level={4} style={{ marginTop: 0, marginBottom: 16 }}>
            Contact {contactId}
          </Typography.Title>
          <CallDetailView detail={detail} loading={loading} contactId={contactId} />
        </>
      )}
    </>
  );
}
